<template>
	<div style="position: relative;">
		<div style="position: relative;">

			<div style="position: relative;font-size: 0;">
				<img src="../assets/top.jpg" style="width: 100%;" />
			</div>
			<div class="zzz">
				<div align="center">
					<div>
						<div
							style="text-align: center;position: relative;width: 90%;margin: 0 auto;margin-top: -1px;padding-top: 20px;">
							<div>
								<img @click="shuoming=true" src="../assets/dj.png" style="width: 80%;" />
							</div>
							<div style="padding-top: 30px;">
								<div class="titleDiv">
									<img src="../assets/zpbt.png" style="width: 100%;" />
								</div>
								<div class="inputDiv">
									<input v-model="zpname" id="zpname" type="text" placeholder="请输入作品标题"
										class="input" />
								</div>
							</div>
							<div style="margin-top: 25px;">
								<div class="titleDiv">
									<img src="../assets/zplb.png" style="width: 100%;" />
								</div>
								<div class="inputDiv">
									<!-- <input type="text" placeholder="请输入作品形式" class="input" /> -->
									<div class="xsdiv" style="text-align: left;">
										<div @click="xzxs(1)" style="display: flex;align-items: center;">
											<img class="xstp" id="xs1" :src="categoryType==1?xz:wxz"
												style="width: 1rem;margin: 10px;" />
											<div>摄影类</div>
										</div>
										<div @click="xzxs(2)" style="display: flex;align-items: center;">
											<img class="xstp" id="xs2" :src="categoryType==2?xz:wxz"
												style="width: 1rem;margin: 10px;" />
											<div>短视频类</div>
										</div>
									</div>
								</div>
							</div>

							<div v-if="categoryType==1" style="margin-top: 25px;">
								<div class="titleDiv">
									<img src="../assets/zpnr.png" style="width: 100%;" />
								</div>
								<div class="inputDiv">
									<div class="xsdiv" style="padding: 15px 10px 5px;position: relative;">
										<van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize"
											:after-read="afterRead" v-model="fileList" @delete="deleteImg" accept="image/*" />
									</div>
								</div>
							</div>
							
							<div v-if="categoryType==2" style="margin-top: 25px;">
								<div class="titleDiv">
									<img src="../assets/zpnr.png" style="width: 100%;" />
								</div>
								<div class="inputDiv">
									<div class="xsdiv" style="padding: 15px 10px 5px;position: relative;">
										<van-uploader :max-size="800 * 1024 * 1024" @oversize="onOversize2" :max-count="1"
											:after-read="afterReadVideo" v-model="fileListVideo" @delete="deleteImg" accept="video/mp4,video/MP4" />
									</div>
								</div>
							</div>

							<div v-if="categoryType==2" style="margin-top: 25px;">
								<div class="titleDiv">
									<img src="../assets/zpfm.png" style="width: 100%;" />
								</div>
								<div class="inputDiv">
									<div class="xsdiv" style="padding: 15px 10px 5px;position: relative;">
										<van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" :max-count="1"
											:after-read="afterRead2" v-model="fileList2" @delete="deleteImg" accept="image/*" />
									</div>
								</div>
							</div>


							<div style="margin-top: 25px;">
								<div class="titleDiv">
									<img src="../assets/zpsm.png" style="width: 100%;" />
								</div>
								<div class="inputDiv">
									<textarea v-model="zpintroduction" id="zpintroduction" maxlength="100" type="text"
										placeholder="请输入作品简要说明（100字以内）" class="textarea"></textarea>
								</div>
							</div>
							<div style="margin-top: 25px;">
								<div class="titleDiv" style="text-align: center;">
									<img src="../assets/zzxm.png" style="width: 100%;" />
								</div>
								<div class="inputDiv">
									<input v-model="username" id="username" type="text" placeholder="请输入作者姓名" class="input" />
								</div>
							</div>

							<div style="margin-top: 25px;">
								<div class="titleDiv">
									<img src="../assets/lxdh.png" style="width: 100%;" />
								</div>
								<div class="inputDiv">
									<input v-model="phone" id="phone" type="text" placeholder="请输入联系电话" class="input" />
								</div>
							</div>
							<div style="margin-top: 30px;">
								<img @click="tijiao()" src="../assets/tj.png" style="width: 40%;" />
							</div>
							<div style="margin-top: 30px;">
								<img src="../assets/logo.png" style="width: 60%;" />
							</div>
							<div style="height: 10px;"></div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div v-if="shuoming" id="shuoming"
			style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);overflow-y: auto;">
			<div style="text-align: center;padding: 30px 0;">
				<img src="../assets/xq.jpg" style="width: 85%;" />
				<div>
					<img @click="shuoming=false" src="../assets/buanbi.png"
						style="width: 40px;margin-top: 30px;" />
				</div>

			</div>
		</div>
		<div id="jiazai"
			style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);display: none;z-index: 600;">
			<div style="position: absolute;top: 45%;;width: 100%;" align="center">
				<img src="../assets/loading.gif" style="width: 30px;" />
				<!-- <div style="color: #FFFFFF;font-size: 1rem;">正在生成海报</div> -->
			</div>
		</div>

		<div id="scing"
			style="z-index: 9999;position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);display: none;">
			<div
				style="color: #FFFFFF;font-size: 1rem;text-align: center;position: absolute;top: 45%;left: 0%;transform: translateY(-50%);width: 100%;">
				<img src="../assets/loading.gif" style="width: 30px;" />
				<div id="scnum">已上传20%</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';

	import Uploader from 'vant/lib/uploader';
	import 'vant/lib/uploader/style';
	Vue.use(Uploader);

	Vue.use(Toast);
	export default {
		name: 'HomeIndex',
		components: {

		},
		data() {
			return {
				shuoming:false,
				zpcategory: null,
				categoryType: null,

				wxz: require("../assets/wxz.png"),
				xz: require("../assets/xz.png"),

				username: null,
				phone: null,

				zpname: null,
				zpurl: null,
				zpintroduction: null,
				imgurl: null,


				fileList: [],
				fileList2: [],
				fileListVideo: [],
				// fileList: [
				//         { url: 'https://img01.yzcdn.cn/vant/leaf.jpg' },
				//         // Uploader 根据文件后缀来判断是否为图片文件
				//         // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
				//         { url: 'https://cloud-image', isImage: true },
				//       ],
				picurl_samll: null,
				picurl: null,
			}
		},

		methods: {
			xzxs(id) {
				this.categoryType = id
				if (id == 1) {
					this.zpcategory = '摄影类'
				} else {
					this.zpcategory = '短视频类'
				}
			},
			tijiao() {
				if (!this.zpname) {
				
					Toast("请输入作品标题")
					return;
				}
				
				
				let zpurl = []
				let imgurl = []
				if (this.categoryType) {
					if (this.categoryType==1) {
						
						if (this.fileList.length == 0) {
						
							Toast("请先上传作品")
							return;
						}
						for (let i = 0; i < this.fileList.length; i++) {
						
							zpurl.push(this.fileList[i].picurl)
						}
						
					} else if (this.categoryType==2){
						
						if (this.fileListVideo.length == 0) {
						
							Toast("请先上传作品")
							return;
						}
						for (let i = 0; i < this.fileListVideo.length; i++) {
						
							zpurl.push(this.fileListVideo[i].picurl)
						}
						
						
						
						if (this.fileList2.length == 0) {
						
							Toast("请先上传封面")
							return;
						}
						for (let i = 0; i < this.fileList2.length; i++) {
						
							imgurl.push(this.fileList2[i].picurl)
						}
						
						
					}
				}else{
					
					Toast("请选择作品类别")
					return;
				}
				if (!this.zpintroduction) {
					
					Toast("请输入作品说明")
					return;
				}
				
				if (!this.username) {
					
					Toast("请输入作者姓名")
					return;
				}
				
				
				if (!this.phone) {
					
					Toast("请填写联系电话")
					return;
				}
				
				
				
				if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
					Toast("请输入正确的手机号码")
					return;
				}
				
				var datajson = {
					"username":this.username,
					"phone":this.phone,
					"zpcategory":this.zpcategory,
					"zpname":this.zpname,
					"zpurl":zpurl.join(),
					"zpintroduction":this.zpintroduction,
					"imgurl":imgurl.join()
				};
				datajson = JSON.stringify(datajson);
				$.ajax({
					type: "get",
					url: "https://appapi.hebei.com.cn/api/2026kjxazbqmyxzj/api/receive.php?message=" + datajson,
					datatype: "json",
					beforeSend: function() {
						$('#jiazai').show()
					},
					complete: function() {
						$('#jiazai').hide()
					},
					//成功返回之后调用的函数
					success: (data)=> {
						console.log("data：",data)
						data = JSON.parse(data)
						if (data.code + '' == '1') {
							this.username = ''
							this.phone = ''
							this.zpname = ''
							this.zpcategory = ''
							this.zpintroduction = ''
							this.fileList = []
							this.fileList2 = []
							this.fileListVideo = []
							
							Toast("提交信息成功")
						} else {
							
							Toast(data.data)
						}
					},
					error: function(data) {
						Toast("提交信息失败，请重试")
				
					}
				})

			},
			deleteImg(file, detail) {
				console.log("deleteImg:", {
					file,
					detail
				})
			},
			onOversize(file) {
				console.log(file);
				Toast('文件大小不能超过10MB');
			},
			onOversize2(file) {
				console.log(file);
				Toast('文件大小不能超过800MB');
			},
			afterRead(file, detail) {
				// 此时可以自行将文件上传至服务器
				console.log(file);
				let that = this
				file.status = 'uploading';
				file.message = '上传中...';

				var url = "https://appapi.hebei.com.cn/api/2026kjxazbqmyxzj/api/imgupload.php"; // 接收上传文件的后台地址

				var form = new FormData(); // FormData 对象
				form.append("file", file.file); // 文件对象

				let xhr = new XMLHttpRequest(); // XMLHttpRequest 对象
				xhr.open("post", url, true); //post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
				xhr.onload = uploadComplete; //请求完成
				xhr.onerror = uploadFailed; //请求失败

				xhr.upload.onprogress = progressFunction; //【上传进度调用方法实现】


				xhr.send(form); //开始上传，发送form数据

				//上传成功响应
				function uploadComplete(evt) {
					//服务断接收完文件返回的结果

					var data = JSON.parse(evt.target.responseText);
					console.log(data)
					console.log(JSON.stringify(data))
					if (data.code == 1) {
						file.picurl = data.data.picurl
						file.picurl_samll = data.data.picurl_samll
						file.status = 'done';
						file.message = '';
					} else {
						// alert("上传失败:" + data.msg);
						// showtips({
						// 	message: data.msg
						// }, 1500);
						Toast(data.msg);
						file.status = 'failed';
						file.message = '上传失败';
						// that.fileList=[]
						that.fileList.splice(detail.index, 1);
					}
				}
				//上传失败
				function uploadFailed(evt) {
					Toast('上传失败');
					file.status = 'failed';
					file.message = '上传失败';
					that.fileList = []
					that.fileList.splice(detail.index, 1);
				}
				//取消上传
				function cancleUploadFile() {
					xhr.abort();
				}

				//上传进度实现方法，上传过程中会频繁调用该方法
				function progressFunction(evt) {

					file.message = "已上传" + Math.round(evt.loaded / evt.total * 100) + "%";
				}

			},
			
			
			afterRead2(file, detail) {
				// 此时可以自行将文件上传至服务器
				console.log(file);
				let that = this
				file.status = 'uploading';
				file.message = '上传中...';
			
				var url = "https://appapi.hebei.com.cn/api/2026kjxazbqmyxzj/api/imgupload.php"; // 接收上传文件的后台地址
			
				var form = new FormData(); // FormData 对象
				form.append("file", file.file); // 文件对象
			
				let xhr = new XMLHttpRequest(); // XMLHttpRequest 对象
				xhr.open("post", url, true); //post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
				xhr.onload = uploadComplete; //请求完成
				xhr.onerror = uploadFailed; //请求失败
			
				xhr.upload.onprogress = progressFunction; //【上传进度调用方法实现】
			
			
				xhr.send(form); //开始上传，发送form数据
			
				//上传成功响应
				function uploadComplete(evt) {
					//服务断接收完文件返回的结果
			
					var data = JSON.parse(evt.target.responseText);
					console.log(data)
					console.log(JSON.stringify(data))
					if (data.code == 1) {
						file.picurl = data.data.picurl
						file.picurl_samll = data.data.picurl_samll
						file.status = 'done';
						file.message = '';
					} else {
						// alert("上传失败:" + data.msg);
						// showtips({
						// 	message: data.msg
						// }, 1500);
						Toast(data.msg);
						file.status = 'failed';
						file.message = '上传失败';
						// that.fileList=[]
						that.fileList2.splice(detail.index, 1);
					}
				}
				//上传失败
				function uploadFailed(evt) {
					Toast('上传失败');
					file.status = 'failed';
					file.message = '上传失败';
					that.fileList2 = []
					that.fileList2.splice(detail.index, 1);
				}
				//取消上传
				function cancleUploadFile() {
					xhr.abort();
				}
			
				//上传进度实现方法，上传过程中会频繁调用该方法
				function progressFunction(evt) {
			
					file.message = "已上传" + Math.round(evt.loaded / evt.total * 100) + "%";
				}
			
			},
			
			
			afterReadVideo(file, detail) {
				// 此时可以自行将文件上传至服务器
				console.log(file);
				let that = this
				file.status = 'uploading';
				file.message = '上传中...';
				
				var video_url=""
				var sign_file_url = ''
				let xhr = new XMLHttpRequest();
				$.ajax({
					type: "get",
					url: "https://appapi.hebei.com.cn/api/2026kjxazbqmyxzj/api/bigfileupload.php",
					datatype: "json",
					//成功返回之后调用的函数
					success: function(data2) {
						
						var url = data2; // 接收上传文件的后台地址
						sign_file_url = data2
						// var form = new FormData(); // FormData 对象
						// form.append("file", fileObj); // 文件对象
						
						xhr.open("put", url, true); //post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
						xhr.onload = uploadVideoComplete; //请求完成
						xhr.onerror = uploadFailed; //请求失败
						
						xhr.upload.onprogress = progressFunction; //【上传进度调用方法实现】
						
						xhr.send(file.file); //开始上传，发送form数据
					},
					error: function(){
						alert("获取签名失败")
					}
				})
			
				
			
				//上传成功响应
				function uploadVideoComplete(evt) {
					//服务断接收完文件返回的结果
			
					file.status = 'done';
					file.message = '';
					
					video_url = sign_file_url.split('?')[0]
					video_url = video_url.split("https://yanfa-upload-1330455741.cos.ap-beijing.myqcloud.com/")[1]
					file.picurl = video_url
				}
				//上传失败
				function uploadFailed(evt) {
					Toast('上传失败');
					file.status = 'failed';
					file.message = '上传失败';
					that.fileListVideo = []
					that.fileListVideo.splice(detail.index, 1);
				}
				//取消上传
				function cancleUploadFile() {
					xhr.abort();
				}
			
				//上传进度实现方法，上传过程中会频繁调用该方法
				function progressFunction(evt) {
			
					file.message = "已上传" + Math.round(evt.loaded / evt.total * 100) + "%";
				}
			
			},

		},
		mounted() {

		}
	}
</script>

<style scoped>
	.zzz {
		background-image: url(../assets/bg.png);
		background-size: 100% auto;
		background-repeat: repeat-y;
	}

	.titleDiv {
		text-align: left;
		width: 45%;
		margin: 0 auto;
		position: relative;
		pointer-events: none;
	}

	.inputDiv {
		margin-top: 5px;
	}

	.input {
		width: 85%;
		border: 1px solid #8e9f3f;
		outline: none;
		height: 40px;
		border-radius: 6px;
		padding-left: 10px;
		font-size: 1rem;
		color: #90b003;
		background: rgba(255, 255, 255, 0.6);
		box-sizing: border-box;
	}

	.input::placeholder {
		color: #90b003;
	}

	.xsdiv {

		box-sizing: border-box;
		width: 85%;
		margin: 0 auto;
		border-radius: 6px;
		/* box-shadow: 3px 3px 13px rgba(115, 193, 255, 1); */
		font-size: 1rem;
		box-sizing: border-box;
		padding: 10px 0 10px 10px;
		color: #90b003;
		background: rgba(255, 255, 255, 0.6);
		text-text-align: center;
		border: 1px solid #8e9f3f;
	}

	.textarea {

		box-sizing: border-box;
		width: 85%;
		outline: none;
		border-radius: 6px;
		/* box-shadow: 3px 3px 13px rgba(115, 193, 255, 1); */
		font-size: 1rem;
		color: #90b003;
		background: rgba(255, 255, 255, 0.6);
		height: 120px;
		resize: none;
		padding: 10px 10px 0 10px;
		border: 1px solid #8e9f3f;
	}

	.textarea::placeholder {
		color: #90b003;
	}

	.titlewz {
		font-size: 1rem;
		margin-top: 3px;
		white-space: nowrap;
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>